<template>
    <section>
      <b-field>
        <b-input
          v-model="prompt"
          type="text"
          placeholder="Enter prompt text"
        />
      </b-field>
      <b-field>
        <b-input
          v-model="generatedText"
          type="text"
          placeholder="Enter generated text"
        />
      </b-field>
      <b-field>
        <b-button @click="addAnnotation">Add Annotation</b-button>
      </b-field>
      {{  annotationsList }}
      <b-field>
        <b-table :data="annotationsList">
          <template slot-scope="props">
            <b-table-column
              field="prompt"
              label="Prompt Text"
            >
              {{ props.row.prompt }}
            </b-table-column>
            <b-table-column
              field="generatedText"
              label="Generated Text"
            >
              {{ props.row.generatedText }}
            </b-table-column>
          </template>
        </b-table>
      </b-field>
    </section>
  </template>
  
  <script>
  export default {
    data() {
      return {
        prompt: '',
        generatedText: '',
        annotationsList: []
      };
    },
    methods: {
      addAnnotation() {
        if (!this.prompt || !this.generatedText) return;
        this.annotationsList.push({
          prompt: this.prompt,
          generatedText: this.generatedText
        });
        this.prompt = '';
        this.generatedText = '';
      }
    }
  };
  </script>
  